import TextareaInput from "../../../../../components/input/TextareaInput";
import Input from "../../../../../components/input/Input";
import { useWebsite } from "../Context/WebSiteContext";
import { useState } from "react";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import Modal from "../../../../../components/modal/Modal";

const AboutSite = ({ control, setValue }) => {
  const { formData, updateFormData } = useWebsite();
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [customImage, setCustomImage] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleFileUpload = (event) => {
    const file = event.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setCustomImage(e.target.result);
        updateFormData("sobreNos", "imagem", e.target.result);
        setValue("sobreNos.imagem", e.target.result, { shouldDirty: true });
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchImages = async () => {
    try {
      setLoading(true);
      const endpoint = searchTerm
        ? `https://api.unsplash.com/search/photos?query=${searchTerm}&per_page=10&client_id=fz-nQ-MukgsFtt_lrV0sgRlxWFGMX9LwIvpPwmB4g20`
        : `https://api.unsplash.com/photos/random?count=10&client_id=fz-nQ-MukgsFtt_lrV0sgRlxWFGMX9LwIvpPwmB4g20`;

      const response = await fetch(endpoint);
      const data = await response.json();
      const images = searchTerm ? data.results : data;

      const formattedImages = images.map((image) => ({
        id: image.id,
        urls: image.urls,
        alt_description: image.alt_description,
        autor: image.user.name,
      }));
      setImages(formattedImages);
    } catch (error) {
      setImages([]);
    } finally {
      setLoading(false);
    }
  };

  const headerTemplate = (
    <div className="d-flex justify-content-between align-items-center gap-2">
      <span>Escolha ou envie uma imagem</span>
      <span className="p-input-icon-left w-75">
        <InputText
          value={searchTerm}
          placeholder="Buscar Imagens"
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") fetchImages();
          }}
          style={{
            width: "100%",
            border: "2px solid #0d9488",
            borderRadius: "30px",
            boxShadow: "0 2px 8px 0 rgba(138,66,232,0.08)",
            paddingLeft: "2.2rem",
            fontWeight: 500,
            fontSize: "1.05rem",
            background: "#fff",
          }}
        />
      </span>
      <Button
        icon="pi pi-refresh"
        className="p-button-rounded p-button-outlined me-2"
        tooltip="Recarregar imagens"
        onClick={fetchImages}
        disabled={loading}
      />
    </div>
  );

  return (
    <div className="p-4">
      <TextareaInput
        control={control}
        label="Descrição Detalhada"
        name="sobreNos.sobre_empreendimento"
        className="form-control mb-4"
        rows={5}
        defaultValue={formData.sobreNos?.sobre_empreendimento || ""}
        onChange={(e) => {
          updateFormData("sobreNos", "sobre_empreendimento", e.target.value);
          setValue("sobreNos.sobre_empreendimento", e.target.value);
        }}
      />

      {/* Botão para abrir modal */}
      <div className="mt-4 text-center">
        <Button
          type="button"
          label="Adicionar Imagem da Seção Sobre"
          icon="pi pi-plus"
          className="p-button-primary p-button-rounded p-3"
          onClick={() => {
            setModalVisible(true);
            fetchImages();
          }}
        />
      </div>

      {/* Modal de seleção */}
      <Modal
        visible={modalVisible}
        onHide={() => setModalVisible(false)}
        dynamicTitle={headerTemplate}
        style={{ width: "50vw" }}
      >
        {loading ? (
          <div className="flex justify-content-center">
            <Skeleton width="100%" height={400} />
          </div>
        ) : (
          <>
            <div className="row">
              {images.map((image) => (
                <div key={image.id} className="col-sm-6 col-md-4 col-lg-3 mb-4">
                  <div className="position-relative">
                    <img
                      src={image.urls.regular}
                      alt={image.alt_description}
                      className={classNames("w-100 rounded", {
                        "border-2 border-primary":
                          selectedImage === image.urls.full,
                        "p-2": selectedImage === image.urls.full,
                      })}
                      style={{
                        width: "300px",
                        height: "200px",
                        margin: "0 auto",
                      }}
                      onClick={() => {
                        setSelectedImage(image.urls.full);
                        setCustomImage(null);
                        updateFormData("sobreNos", "imagem", image.urls.full);
                        setValue("sobreNos.imagem", image.urls.full, {
                          shouldDirty: true,
                        });
                      }}
                    />
                    {selectedImage === image.urls.full && (
                      <i className="pi pi-check-circle position-absolute top-0 end-0 p-2 text-success" />
                    )}
                  </div>
                  {image.autor && (
                    <div className="text-center mt-1">
                      <span className="text-muted" style={{ fontSize: "0.7rem" }}>
                        autor: {image.autor}
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-4">
              <FileUpload
                mode="basic"
                accept="image/*"
                customUpload
                uploadHandler={handleFileUpload}
                chooseLabel="Enviar Imagem"
                className="w-100"
              />
              {customImage && (
                <div className="mt-2 text-center">
                  <img
                    src={customImage}
                    alt="Imagem Enviada"
                    style={{
                      maxWidth: "120px",
                      maxHeight: "120px",
                      objectFit: "cover",
                    }}
                    className="rounded"
                  />
                </div>
              )}
            </div>
          </>
        )}

        <div className="text-center mt-4">
          <Button
            label="Usar esta imagem"
            icon="pi pi-check"
            className="p-button-success"
            disabled={!selectedImage && !customImage}
            onClick={() => {
              if (selectedImage || customImage) {
                setModalVisible(false);
              }
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default AboutSite;
